<div class="section-margin">
  <div class="container container-lg">
    <div class="margin0">
      <div>
        <div class="clearfix"></div>
        <div class="container container-lg min-heightcontainer be-buy-page-wrap margin0">
          <div class="border-div margin0">
            <div class="tabstyle2 offerdetailstab-padding pos-relative">
              <ul class="switchingproperty margin-bottom-15 offerlistingtab">
                <li [class.active]="activeMenu === usertab.Properties" *ngIf="IsShowProperties">
                  <a (click)="onAssociationsTabClick(usertab.Properties)">
                    Properties
                  </a>
                </li>
                <li [class.active]="activeMenu === usertab.Exchange" *ngIf="IsShowExchange">
                  <a (click)="onAssociationsTabClick(usertab.Exchange)">
                    1031 Exchange
                  </a>
                </li>
                <li [class.active]="activeMenu === usertab.Offers" *ngIf="IsShowOffer">
                  <a (click)="onAssociationsTabClick(usertab.Offers)">
                    Offers
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <div class="margin-top-30" *ngIf="activeMenu === usertab.Properties&&!IsDes">
                <div class="d-flex filter-header-rt floatinghead clearfix" *ngIf="Isemployee&&propertyList?.length>0&&permissionService.hasPermission(moduleId,Actions.AssociationsEdit)">
                  <div class="rightside d-flex ml-auto" *ngIf="!IsEditClicked">
                    <div style="padding-left: 5px">
                      <button type="button" class="btn  btn-circle btn-green"
                              tooltip="Update" triggers="mouseenter:mouseleave"
                              placement="left" (click)="editUserContacts()">
                        <i aria-hidden="true" class="icofont icofont-ui-edit icon"></i>
                      </button>
                    </div>
                  </div>
                  <div class="rightside d-flex ml-auto margin-bottom-15" *ngIf="IsEditClicked">
                    <label style="padding-top:17px;">Assign New Primary</label>
                    <div style="padding-left: 5px; padding-top: 10px;">
                      <label class="select">
                        <select name="cmbBroker" class="form-control " [(ngModel)]="bulkBrokerId" (click)="onBrokerClick();" (change)="onBulkBrokerChange($event)">
                          <option value="0">Select</option>
                          <option *ngFor="let broker of brokers" [(ngValue)]="broker.Id">{{broker.Name}}</option>
                        </select>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="cf"></div>
                <div class="table-responsive table-fixed table-v-scroll margin0" style="width: 100%">
                  <table class="table basictable row-border hover" datatable [dtOptions]="dtoptions1">
                    <thead>
                      <tr>
                        <th data-orderable="false" style="width:5px" [hidden]="!IsEditClicked">
                          <label class="custom-checkbox withoutlabel">
                            <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i>Select
                          </label>
                        </th>
                        <th style="width:2px" [hidden]="!IsEditClicked">
                        </th>
                        <th>Property Name</th>
                        <th>Status</th>
                        <th>Offers</th>
                        <th data-orderable="false">Secondary Contact</th>
                        <th data-orderable="false" [hidden]="!IsEditClicked">Assign New Primary Contact</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let property of propertyList;let i = index">
                        <td [hidden]="!IsEditClicked">
                          <label class="custom-checkbox withoutlabel">
                            <input type="checkbox" [(ngModel)]="property.IsSelected" (change)="onCheckboxChange($event,property.Id);" class="ng-pristine ng-valid ng-touched"><i></i>
                          </label>
                        </td>
                        <td [hidden]="!IsEditClicked"></td>
                        <td class="sticky-left">
                          <div style="display:table">
                            <p><a target="_blank" href="javascript:void(0);" routerLink="/viewproperty/{{property.Guid}}">{{property.PropertyName}}</a></p>
                          </div>
                        </td>
                        <td>
                          <p [ngClass]="{'redtextlabel':(property.Status === 'Closed' || property.Status === 'Sold'),'greentextlabel':property.Status === 'Available','orangetextlabel':property.Status === 'Under Contract','not-available':property.Status === 'Not Available','Off-Market':property.Status === 'Off-Market'}">{{ property.Status }}</p>
                        </td>
                        <td>
                          <p>{{property.OffersCount}}</p>
                        </td>
                        <td class="tool-top-box">
                          <p tooltip="{{property.SecondaryContact}}" container="body">{{GetSecondaryContactWithCount(property.SecondaryContact)}}</p>
                        </td>
                        <td [hidden]="!IsEditClicked">
                          <label class="select">
                            <select name="cmbBroker" class="form-control " (change)="onBrokerChange($event,property)" [(ngModel)]="property.BrokerId">
                              <option value="0">Select</option>
                              <option *ngFor="let broker of brokers" value="{{broker.Id}}">{{broker.Name}}</option>
                            </select>
                          </label>
                        </td>
                      </tr>

                    </tbody>
                    <tfoot>
                      <tr *ngIf="propertyList?.length == 0&&!IsDataProcessing">
                        <td colspan="6" class="odd no-data-available">
                          <div class="nodata">
                            <i class="fa fa-exclamation-triangle icon"></i>
                            <p>No Data Available</p>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>

                </div>
                <div class="text-right margin-top-10" *ngIf="activeMenu === usertab.Properties&&IsEditClicked">
                  <button type="button" class="btn btn-default btn-lg" (click)="clearSelectedContact()">Cancel</button>
                  <button class="btn btn-success  btn-lg" (click)="saveUserContacts()">Save</button>
                </div>

              </div>
              <div class="margin-top-30" *ngIf="activeMenu === usertab.Properties&&IsDes">
                <des-associations [CurrentUser]="CurrentUser" [principalDetails]="principalDetails"></des-associations>
              </div>
              <div class="margin-top-30" *ngIf="activeMenu === usertab.Exchange">
                <user-exchanges [CurrentUser]="CurrentUser" [principalDetails]="principalDetails"></user-exchanges>
              </div>
              <div class="margin-top-30" *ngIf="activeMenu === usertab.Offers">
                <user-offers [CurrentUser]="CurrentUser" [principalDetails]="principalDetails"></user-offers>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



